import React, { useEffect, useState } from 'react';
import { Layout, Justify, Segment, Checkbox } from 'tea-component';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';

import { connect, useDispatch } from 'umi';
import CardLoading from '@/pages/opinion/components/CardLoading';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import ChartsBox from '../components/ChartsBox';
import '@/pages/opinion/assets/scss/pages/stats/topic.scss';
import {
  buriedBtnPoint,
  useInitBuriedPointInfo,
} from '@/pages/opinion/operationLog/buriedPoint';
import StatsTopicPoint from '@op/operationLog/pages/statsTopic';
import ContentBody from '@/pages/opinion/components/ContentBody';
import BubbleCommon from '../../../components/BubbleCommon/BubbleCommon';
import {
  statsTopicNegativeText,
  statsTopicPositiveText,
} from '@/pages/opinion/components/BubbleCommon';
import { PAGE_NAME } from '@op/constants/page';
import DetailPageTable, { ChannelType } from '@op/components/DetailPageTable';
const { Content } = Layout; 

function Topic({ gameInfo, topic, topicLoading,wholeGameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: StatsTopicPoint });
  const {
    loading,
    filter,
    changeFilter,
    filterOptions,
    scrollBody,
    changeTopicList,
    topicList,
  } = useFilterDataHook({
    gameInfo,
    pageName: 'Stats_Topic',
  });
  const { formatMessage } = useLanguage();
  const dispatch = useDispatch();
  // 是否显示排除未分类评论按钮
  const [isShowExclude, setIsShowExclude] = useState(true);
  const [sentimentType, setSentimentType] = useState<
    'negative' | 'positive' | ''
  >('');
  const [channelType, setChannelType] = useState<ChannelType>('social');
  useEffect(() => {
    if (!gameInfo || !filter) return;
    const payload = {
      ...filter,
      ...gameInfo,
      statistics_field: 'topic',
      version_time: '1',
      top_n: 15,
      need_others: false,
      include_unlabeled_reviews: !isShowExclude,
      metrics: [
        'mentions',
        'avg_sentiment',
        'negative_mentions',
        'neutral_mentions',
        'positive_mentions',
      ],
    };
    if (sentimentType) {
      payload.sentiment_type = sentimentType;
    }
    dispatch({
      type: 'opinionPerformance/getOverviewTopicTimeline',
      payload,
    });
  }, [gameInfo, filter, isShowExclude, sentimentType]);

  return (
    <Content className="dbo-topic dbo-stats" ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.TOPIC}
        contentHeard={
          <Content.Header title={formatMessage({ id: PAGE_NAME.TOPIC })} />
        }
      >
        <FilterFixed
          filter={filterOptions}
          scrollBody={scrollBody}
          confirm={(value: any) => {
            changeFilter({...value, ...gameInfo});
          }}
          backCondOriginData={(value) => {
            changeTopicList({ topic_trans: value.topic_trans, key_topic: {} });
          }}
        ></FilterFixed>
        <Justify
          className="dbo-stats-sgement-justify"
          left={
            <Segment
              className="segment-light"
              value={sentimentType}
              onChange={(value) => {
                buriedBtnPoint('STO_sentiment', value || 'total');
                setSentimentType(value as any);
              }}
              options={[
                {
                  text: formatMessage({ id: 'Total-2' }),
                  value: '',
                },
                {
                  text: (
                    <BubbleCommon
                      placement="top"
                      tipsMap={statsTopicPositiveText}
                      showIcon={false}
                    >
                      {formatMessage({ id: 'Positive' })}
                    </BubbleCommon>
                  ),
                  value: 'positive',
                },
                {
                  text: (
                    <BubbleCommon
                      placement="top"
                      tipsMap={statsTopicNegativeText}
                      showIcon={false}
                    >
                      {formatMessage({ id: 'Negative' })}
                    </BubbleCommon>
                  ),
                  value: 'negative',
                },
              ]}
            />
          }
          right={
            <div className="dbo-stats-sgement-justify-checkbox">
              <Checkbox
                onClick={() => setIsShowExclude(!isShowExclude)}
                value={isShowExclude}
              >
                {formatMessage({ id: 'Exclude unlabeled reviews' })}
              </Checkbox>
            </div>
          }
        />
        <CardLoading loading={loading}>
          <ChartsBox
            data={topic}
            loading={topicLoading}
            filter={filter}
            dataType="topic"
          ></ChartsBox>
          <DetailPageTable
            hasNews={true}
            channelType={channelType}
            setChannelType={setChannelType}
            gameInfo={gameInfo}
            defaultPageInfo={{ page: 1, page_size: 5 }}
            filter={filter}
            hasPageable={false}
            wholeGameInfo={wholeGameInfo}
          ></DetailPageTable>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { loading, opinionCommon, opinionPerformance } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,

    topicLoading:
      loading.effects['opinionPerformance/getOverviewTopicTimeline'],
    topic: opinionPerformance.topicTimeline,
  };
})(Topic);
